/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/react-in-jsx-scope */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAccount } from "wagmi";
import {
  Box,
  useTheme,
  Grid,
  MenuItem,
  Typography,
  ListSubheader,
  TextField,
  Card,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  OutlinedInput,
  FormHelperText,
  DialogActions,
  debounce,
} from "@mui/material";
import { LoadingButton as Button } from "@mui/lab";
import { Alert } from "@/components/Modal";
import { POST_TYPE } from "@/@types/EnumType";
import { observer, inject } from "mobx-react";
import { autorun } from "mobx";
import { IAsset, ICurrency } from "@/interfaces";
import Store from "@/store";
import CommonStore, { UI_ACTION_STATE } from "@/store/common";
import { UserStore } from "@/store/user";
import MarketContractStore from "@/store/contract";
import { ethers } from "ethers";
import { enqueueSnackbar } from "notistack";
import { IAlertData } from "@/@types/Alert";
import MyWalletStore from "@/store/my-wallet";
import { formatedBigNumber, requestNotificationPermission } from "@/utility";
import { NumberInput } from "@/components/Form";
import { Controller, useForm } from "react-hook-form";
import DialogInprogress from "@/components/DialogInprogress/DialogInprogress";

const CreatePost = inject(
  Store.type.userStore,
  Store.type.commonStore,
  Store.type.tradingStore,
  Store.type.contractStore,
  Store.type.myWalletStore,
)(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  observer((props: any) => {
    const userStore = props[Store.type.userStore] as UserStore;
    const commonStore = props[Store.type.commonStore] as CommonStore;
    const myWalletStore = props[Store.type.myWalletStore] as MyWalletStore;
    const contractStore = props[
      Store.type.contractStore
    ] as MarketContractStore;

    const theme = useTheme();
    const navigate = useNavigate();

    const [isSubmiting, setIsSubmiting] = useState(false);
    const [postType, setPostType] = useState<POST_TYPE>("SELL");
    const {
      register,
      control,
      reset,
      formState: { errors },
      handleSubmit: handleSubmitDeposit,
    } = useForm<{ amount: "" }>();
    const [asset, setAsset] = useState("");
    const [open, setOpen] = useState(false);
    const [openInprogress, setOpenInprogress] = useState(false);
    const [assetError, setAssetError] = useState("");
    const [currency, setCurrency] = useState("");
    const [currencyError, setCurrencyError] = useState("");
    const [merchant, setMerchant] = useState("");
    const [merchantError, setMerchantError] = useState("");
    const [minAmount, setMinAmount] = useState("");
    const [minAmountError, setMinAmountError] = useState("");
    const [maxAmount, setMaxAmount] = useState("");
    const [maxAmountError, setMaxAmountError] = useState("");
    const [price, setPrice] = useState("");
    const [priceError, setPriceError] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [paymentMethodError, setPaymentMethodError] = useState("");
    const [terms, setTerms] = useState("");
    const [termsError, setTermsError] = useState("");
    const [token_amount, setToken_amount] = useState("");
    const [token_amountError, setToken_amountError] = useState("");
    const [alertData, setAlertData] = useState<undefined | IAlertData>();
    const [assetList, setAssetList] = useState<IAsset[]>([]);
    const [currencyList, setCurrencyList] = useState<ICurrency[]>([]);
    const { address } = useAccount();
    const [minAmountLabel, setMinAmountLabel] = useState("Minimum Amount");
    const [maxAmountLabel, setMaxAmountLabel] = useState("Maximum Amount");

    const [paymentList, setPaymentList] = useState<
      (false | JSX.Element)[][] | null
    >(null);
    const onSubmitDeposit = async (data: { amount: string }) => {
      setOpen(false);
      setOpenInprogress(true);

      commonStore.setTransactionProcessing(true);
      try {
        await myWalletStore.deposit(
          assetList.find((a) => a.asset_id === asset)?.address || "",
          ethers.utils.parseEther(data.amount),
        );

        enqueueSnackbar("Transaction successful", {
          variant: "success",
        });
      } catch (error: any) {
        if (
          (error.message as string).includes(
            "reverted: P2PWallet: User with this wallet address is not KYC verified",
          )
        ) {
          enqueueSnackbar(`Transaction failed. Please KYC first to continue.`, {
            variant: "error",
          });
        } else {
          console.error("Error deposit:", error);
          enqueueSnackbar(
            "Transaction failed. Please check your wallet and try again.",
            {
              variant: "error",
            },
          );
        }
      }
      setOpenInprogress(false);
      commonStore.setTransactionProcessing(false);

      reset();
    };
    useEffect(() => {
      const disposeAutorun = autorun(() => {
        if (commonStore && userStore) {
          const list = commonStore?.paymentMethods
            .filter((method) =>
              userStore.myPayments?.find(
                (payment) => payment.payment_method_id === method.payment_id,
              ),
            )
            .map((method) => [
              <ListSubheader
                key={method.payment_id}
                sx={{
                  fontSize: theme.typography.body2.fontSize,
                  lineHeight: theme.typography.body2.lineHeight,
                  mt: "0.875rem",
                  mb: "0.375rem",
                }}
              >
                {method.payment_name}
              </ListSubheader>,
              ...userStore.myPayments
                .filter(
                  (payment) => payment.payment_method_id === method.payment_id,
                )
                .map((payment) => {
                  const paymentAttributes = payment.payment_attributes
                    .filter(
                      (paymentAttribute) =>
                        paymentAttribute.payment_method_attribute
                          ?.preview_order,
                    )
                    .sort(
                      (a, b) =>
                        (a.payment_method_attribute?.preview_order ?? 0) -
                        (b.payment_method_attribute?.preview_order ?? 0),
                    );
                  const itemText = paymentAttributes
                    .map((paymentAttribute) => paymentAttribute.attribute_value)
                    .join(" ");
                  return (
                    <MenuItem key={payment.id} value={payment.id}>
                      {itemText}
                    </MenuItem>
                  );
                }),
            ]);
          setPaymentList(list.length ? list : null);
        }
      });
      return () => {
        disposeAutorun();
      };
    }, [commonStore, userStore]);

    useEffect(() => {
      commonStore.fetchAssets().catch((error) => {
        console.error("Error assets:", error);
      });
      commonStore.fetchCurrencies().catch((error) => {
        console.error("Error currencies:", error);
      });
      const disposeAutorun = autorun(() => {
        const assets = commonStore.assets;
        const currencies = commonStore.currencies;
        if (assets && currencies) {
          setAssetList(assets);
          setCurrencyList(currencies);
        }
      });
      return () => {
        disposeAutorun();
      };
    }, [commonStore]);

    useEffect(() => {
      const disposeAutorun = autorun(async () => {
        const userId = userStore.userId;
        if (userId) {
          userStore.fetchMyPayments(userId).catch((error) => {
            console.error("Error fetch my payments:", error);
          });
          commonStore.fetchPaymentMethods().catch((error) => {
            console.error("Error fetch payment methods:", error);
          });
        }
      });
      return () => {
        disposeAutorun();
      };
    }, [userStore]);

    const handleSubmit = async () => {
      setIsSubmiting(true);
      let isError = false;
      if (!merchant) {
        setMerchantError("Please fill merchant.");
        isError = true;
      } else {
        setMerchantError("");
      }
      if (!asset) {
        setAssetError("Please select asset.");
        isError = true;
      } else {
        setAssetError("");
      }
      if (!currency) {
        setCurrencyError("Please select currency.");
        isError = true;
      } else {
        setCurrencyError("");
      }
      if (!minAmount) {
        setMinAmountError("Please fill minimum quantity.");
        isError = true;
      } else if (Number(minAmount) < 0) {
        setMinAmountError(
          "Minimum quantity must be greater than or equal to zero.",
        );
        isError = true;
      } else {
        setMinAmountError("");
      }
      if (!Number(maxAmount)) {
        setMaxAmountError("Please fill maximum quantity.");
        isError = true;
      } else if (Number(maxAmount) < Number(minAmount)) {
        setMaxAmountError(
          "Maximum quantity must be greater than minimum quantity.",
        );
        isError = true;
      } else {
        setMaxAmountError("");
      }
      if (!Number(price)) {
        setPriceError("Please fill price.");
        isError = true;
      } else if (Number(price) < 0) {
        setPriceError("Price must be greater than zero.");
        isError = true;
      } else {
        setPriceError("");
      }
      if (!paymentMethod) {
        setPaymentMethodError("Please select payment method.");
        isError = true;
      } else {
        setPaymentMethodError("");
      }
      if (!terms) {
        setTermsError("Please fill terms.");
        isError = true;
      } else {
        setTermsError("");
      }
      try {
        const _token_amount = ethers.utils.parseEther(token_amount);
        if (postType === "SELL") {
          const _balance = myWalletStore.myAssets.find(
            (f) => f.asset.asset_id === asset,
          )?.balance;
          if (_balance && _token_amount.gt(_balance)) {
            setToken_amountError("Please refill your balance in your wallet");
            isError = true;
          } else {
            setToken_amountError("");
          }
        }
        if (price && _token_amount && !isError) {
          const totalAmount = _token_amount
            .mul(ethers.utils.parseEther(price))
            .div(ethers.BigNumber.from(10).pow(18));
          if (_token_amount.isZero()) {
            setToken_amountError("Token amount must be greater than zero.");
            isError = true;
          } else if (
            maxAmount &&
            price &&
            ethers.utils
              .parseEther(maxAmount)
              .gt(
                totalAmount
                  .mul(ethers.utils.parseEther(price))
                  .div(
                    ethers.BigNumber.from(10).pow(
                      assetList.find((a) => a.asset_id === asset)?.decimals ||
                        18,
                    ),
                  ),
              )
          ) {
            console.log(ethers.utils.parseEther(maxAmount).toString());
            console.log(
              totalAmount
                .mul(ethers.utils.parseEther(price))
                .div(
                  ethers.BigNumber.from(10).pow(
                    assetList.find((a) => a.asset_id === asset)?.decimals || 18,
                  ),
                )
                .toString(),
            );
            setToken_amountError(
              "Token amount must be greater than or equals to maximum amount.",
            );
            isError = true;
          }
        }
      } catch (error) {
        console.error("Error parse token amount:", error);
        setToken_amountError("Please fill Token amount.");
      }
      if (isError) {
        setIsSubmiting(false);
        return;
      }

      try {
        if (userStore.profile && address) {
          const _asset = commonStore.assets.find(
            (item) => item.asset_id === asset,
          );
          if (!_asset) {
            console.error("Asset not found.");
            enqueueSnackbar("Asset not found.", { variant: "error" });
            return;
          }
          commonStore.setActionState(
            UI_ACTION_STATE.WALLET_CONFIRMATION_PENDING,
          );
          await contractStore.createPost(
            {
              tokenAddress: _asset?.address,
              tokenAmount: ethers.utils.parseEther(token_amount).toString(),
              price: ethers.utils.parseEther(price).toString(),
              minOrder: ethers.utils.parseEther(minAmount).toString(),
              maxOrder: ethers.utils.parseEther(maxAmount).toString(),
              isSell: postType === "SELL",
              isNativeToken: _asset?.address.indexOf("0x0000") === 0,
              fiatCurrency: currency,
              payment_method: paymentMethod,
              post_type: postType,
              asset_id: asset,
              title: merchant,
              description: terms,
            },
            (result) => {
              commonStore.setActionState(result);
            },
          );
          commonStore.setActionState(UI_ACTION_STATE.NONE);
          setAlertData({
            message: "Successfully placed new post!",
            button: {
              text: "View my post",
              method: () => {
                navigate("/trade/my-posts");
              },
            },
          });
          requestNotificationPermission();
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        console.error(e);
        let message = e.message;
        if (e.message.length > 100) {
          message = e.message.substring(0, 100) + "...";
        }
        enqueueSnackbar("Create post failed:" + message, {
          variant: "error",
        });
      } finally {
        setIsSubmiting(false);
        commonStore.setActionState(UI_ACTION_STATE.NONE);
      }
    };
    const handleMerchantChange = (e: any) => {
      const debounced = debounce(() => {
        setMerchant(e.target.value);
      }, 500);
      debounced();
    };
    useEffect(() => {
      console.log(myWalletStore.myAssets);
    }, [myWalletStore.myAssets]);

    return (
      <>
        <Card
          sx={{
            width: "90%",
            maxWidth: "853px",
            mt: "62.5px",
            mb: "50.5px",
            mx: "auto",
            pt: "37.87px",
            pb: "56px",
            px: "66px",
          }}
        >
          <Typography variant="h3" textAlign="center" mb="31.13px">
            Create new post
          </Typography>
          <Grid container columnSpacing="40px" rowSpacing="29px">
            <Grid item sm={12}>
              <TextField
                variant="outlined"
                fullWidth
                label="Merchant"
                type="text"
                required
                name="merchant"
                id="merchant"
                // value={merchant}
                error={!!merchantError}
                helperText={merchantError}
                onChange={handleMerchantChange}
              />
            </Grid>
            <Grid item sm={12}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                <TextField
                  variant="outlined"
                  label="Post type"
                  select={true}
                  type="text"
                  fullWidth
                  required
                  name="postType"
                  id="postType"
                  value={postType}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue === "BUY" || newValue === "SELL") {
                      setPostType(newValue);
                    }
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      color: `${
                        postType === "SELL"
                          ? theme.colors.red
                          : theme.colors.green
                      } !important`,
                      pt: "19.5px",
                      pb: "20.5px",
                    },
                  }}
                >
                  <MenuItem
                    value="SELL"
                    sx={{
                      color: theme.colors.red,
                    }}
                  >
                    SELL POST
                  </MenuItem>
                  <MenuItem
                    value="BUY"
                    sx={{
                      color: theme.colors.green,
                    }}
                  >
                    BUY POST
                  </MenuItem>
                </TextField>
                <TextField
                  variant="outlined"
                  label="Asset"
                  select={true}
                  fullWidth
                  type="text"
                  required
                  name="asset"
                  id="asset"
                  value={asset}
                  error={!!assetError}
                  helperText={assetError}
                  onChange={(e) => setAsset(e.target.value)}
                  sx={{
                    "& .MuiInputBase-input": {
                      pt: "19.5px",
                      pb: "20.5px",
                    },
                  }}
                >
                  {assetList.map((pm) => (
                    <MenuItem key={pm.asset_id} value={pm.asset_id}>
                      {pm.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Stack>
            </Grid>
            <Grid item sm={12}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Payment method"
                  select={true}
                  type="text"
                  required
                  name="paymentMethod"
                  id="paymentMethod"
                  value={paymentMethod}
                  error={!!paymentMethodError}
                  helperText={paymentMethodError}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  sx={{
                    "& .MuiInputBase-input": {
                      pt: "19.5px",
                      pb: "20.5px",
                    },
                  }}
                >
                  {paymentList}
                  {paymentList === null && (
                    <MenuItem
                      onClick={() => {
                        navigate("/profile/payments/create");
                      }}
                    >
                      Add Payment
                    </MenuItem>
                  )}
                </TextField>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Currency"
                  select={true}
                  type="text"
                  required
                  name="currency"
                  id="currency"
                  value={currency}
                  error={!!currencyError}
                  helperText={currencyError}
                  onChange={(e) => {
                    setCurrency(e.target.value);
                    setMaxAmountLabel(`Maximum Amount (${e.target.value})`);
                    setMinAmountLabel(`Minimum Amount (${e.target.value})`);
                  }}
                  sx={{
                    "& .MuiInputBase-input": {
                      pt: "19.5px",
                      pb: "20.5px",
                    },
                  }}
                >
                  {currencyList.map((pm) => (
                    <MenuItem key={pm.id} value={pm.symbol}>
                      {pm.symbol}
                    </MenuItem>
                  ))}
                </TextField>
              </Stack>
            </Grid>
            <Grid item sm={12}>
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                <NumberInput
                  required
                  label={minAmountLabel}
                  name="min_amount"
                  id="min_amount"
                  value={minAmount}
                  error={minAmountError}
                  onChange={(e) => setMinAmount(e.target.value)}
                />
                <NumberInput
                  required
                  label={maxAmountLabel}
                  name="max_amount"
                  id="max_amount"
                  value={maxAmount}
                  error={maxAmountError}
                  onChange={(e) => setMaxAmount(e.target.value)}
                />
              </Stack>
            </Grid>
            <Grid
              item
              sm={12}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  width: "100%",
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                <NumberInput
                  required
                  label="Price / Unit"
                  name="price"
                  id="price"
                  value={price}
                  error={priceError}
                  onChange={(e) => setPrice(e.target.value)}
                />

                <NumberInput
                  required
                  label={
                    asset
                      ? `Token Amount (balance:
                    ${formatedBigNumber(
                      (myWalletStore.myAssets.find(
                        (f) => f.asset.asset_id === asset,
                      ) &&
                        myWalletStore.myAssets.find(
                          (f) => f.asset.asset_id === asset,
                        )?.balance) ||
                        "0",
                    )} 
                    ${
                      myWalletStore.myAssets.find(
                        (f) => f.asset.asset_id === asset,
                      ) &&
                      myWalletStore.myAssets.find(
                        (f) => f.asset.asset_id === asset,
                      )?.asset.symbol
                    }
                    )`
                      : "Token Amount (Please select Asset)"
                  }
                  name="token_amount"
                  id="token_amount"
                  value={token_amount}
                  error={token_amountError}
                  onChange={(e) => setToken_amount(e.target.value)}
                />
              </Stack>
              <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
                {asset && (
                  <Button size="small" onClick={() => setOpen(true)}>
                    Deposit
                  </Button>
                )}
              </Stack>
            </Grid>
            <Grid item sm={12}>
              <TextField
                variant="outlined"
                fullWidth
                label="Terms"
                type="text"
                required
                name="terms"
                rows={4}
                id="terms"
                value={terms}
                error={!!termsError}
                helperText={termsError}
                onChange={(e) => setTerms(e.target.value)}
                multiline={true}
              />
            </Grid>
          </Grid>
          <Box width="fit-content" mx="auto" mt="47px">
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => handleSubmit()}
              loading={isSubmiting}
              sx={{
                boxShadow: "none",
                "&:hover": {
                  boxShadow: "none",
                },
              }}
            >
              Submit your post
            </Button>
          </Box>
          {alertData && <Alert alertData={alertData} />}
        </Card>
        <Dialog
          open={open}
          maxWidth={"md"}
          onClose={() => {
            setOpen(false);
          }}
        >
          <form onSubmit={handleSubmitDeposit(onSubmitDeposit)}>
            <DialogTitle>
              <Typography variant="h4">Deposit</Typography>
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2} sx={{ minWidth: 500 }}>
                <Grid item xs={12} md={12}>
                  <Controller
                    name="amount"
                    control={control}
                    defaultValue={""}
                    rules={{
                      required: "Amount is required",
                      validate: {
                        positive: (value) =>
                          parseFloat(value) > 0 || "Amount must be positive",
                        number: (value: string) => {
                          try {
                            ethers.utils.parseEther(value);
                            return true;
                          } catch (error) {
                            return "Invalid amount";
                          }
                        },
                      },
                    }}
                    render={({ field }) => (
                      <FormControl fullWidth variant="outlined">
                        <OutlinedInput
                          inputProps={{
                            placeholder: "Enter Amount",
                            type: "number",
                          }}
                          sx={{
                            border: "1px solid #e0e0e0",
                            borderRadius: "10px",
                          }}
                          error={!!errors.amount}
                          fullWidth
                          {...field}
                          {...register("amount")}
                        />

                        <FormHelperText error={!!errors.amount}>
                          {!!errors.amount && errors.amount?.message}
                        </FormHelperText>
                      </FormControl>
                    )}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                size="large"
                variant="outlined"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button size="large" variant="contained" type="submit">
                Deposit
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        <DialogInprogress
          open={openInprogress}
          onClose={() => {
            setOpenInprogress(false);
          }}
        />
      </>
    );
  }),
);

export default CreatePost;
